import { Switch } from "react-router-dom";
import { RotaCustomizada } from "shared/components";
import LayoutAutenticado from "shared/layout/LayoutAutenticado";
import LayoutNaoAutenticado from "shared/layout/LayoutNaoAutenticado";
import CadastreSe from "explorer/pages/cadastre-se/CadastreSe";
import CheckoutDiagnostico from "explorer/pages/checkout-diagnostico/CheckoutDiagnostico";
import Diagnostico from "explorer/pages/diagnostico/Diagnostico";
import Diagnosticos from "explorer/pages/diagnosticos/Diagnosticos";
import Home from "explorer/pages/home";
import Login from "explorer/pages/login/Login";
import MeusDados from "explorer/pages/meus-dados/MeusDados";
import NotFound from "shared/pages/not-found/NotFound";
import NovoDiagnostico from "explorer/pages/novo-diagnostico/NovoDiagnostico";
import ResetSenha from "explorer/pages/reset-senha/ResetSenha";
import VerificacaoLogin from "explorer/pages/verificacao-login/VerificacaoLogin";
import LayoutQuiz from "shared/layout/LayoutQuiz";
import LayoutEstagio from "shared/layout/LayoutEstagio";
import Unsubscribe from "shared/pages/unsubscribe/Unsubscribe";
import Convites from "explorer/pages/convites/Convites";
import AceiteConvite from "explorer/pages/aceite-convite/AceiteConvite";
import EasyCheckout from "explorer/pages/easy-checkout/EasyCheckout";
import LayoutBranco from "shared/layout/LayoutBranco";
import Adiantamentos from "explorer/pages/adiantamentos/Adiantamentos";
import LayoutAdiantamento from "shared/layout/LayoutAdiantamentos";
import ConfirmacaoCheckout from "explorer/pages/confirmacao-checkout/ConfirmacaoCheckout";
import Afiliates from "shared/pages/afiliates/Afiliates";
import NewLayout from "shared/layout/NewLayout";
import Quiz from "explorer/pages/quiz/Quiz";
import NewEstagioArtista from "explorer/pages/new-estagio-artista/NewEstagioArtista";
import Distribua from "explorer/pages/distribua/Distribua";
import Metas from "explorer/pages/metas/Metas";
import NewPitching from "explorer/pages/new-pitching/NewPitching";
import PitchingCenter from "explorer/pages/pitching-center/PitchingCenter";
import RecomendacaoCollab from "explorer/pages/recomentacao-collab/RecomendacaoCollab";
import NewReleasesSchedule from "explorer/pages/releases-schedule/new-release-schedule/NewReleasesSchedule";
import NewReleasesScheduleOnlyQuincy from "explorer/pages/releases-schedule/new-release-schedule-only-quincy/NewReleasesScheduleOnlyQuincy";
import ReleasesScheduleList from "explorer/pages/releases-schedule/ReleasesSchedulesCenter";
import StrmClass from "explorer/pages/class/StrmClass";
import StrmHero from "explorer/pages/hero/Hero";
import LayoutHero from "shared/layout/LayoutHero";
import StrmClassDetail from "explorer/pages/class/StrmClassVideo";
import NewQuiz from "explorer/pages/new-quiz/NewQuiz";
import NewAssessment from "explorer/pages/new-asessment/NewAssessment";
import Tour from "explorer/pages/tour/Tour";
// import Playlists from "explorer/pages/playlists/Playlists";
import Promotion from "explorer/pages/promotion/Promotion";
import Touring from "explorer/pages/touring/Touring";
import Pricing from "explorer/pages/pricing/Pricing";
import CentralDistribuicao from "explorer/pages/central-distribuicao/CentralDistribuicao";
import GerenciamentoArtistas from "explorer/pages/gerenciamento-artistas/GerenciamentoArtistas";
import ReportUpload from "explorer/pages/report-upload/ReportUpload";
import AguardandoLogin from "explorer/pages/aguardando-login/AguardandoLogin";
import QuincySwitch from "explorer/pages/Quincy/QuincySwitch";

const Routes = () => {
  return (
    <Switch>
      {/* EXPLORER */}
      <RotaCustomizada path="/" exact component={Home} layout={NewLayout} />
      <RotaCustomizada path="/home" exact component={Home} layout={NewLayout} />
      <RotaCustomizada
        path="/:lang?/adiantamentos"
        exact
        component={Adiantamentos}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/pitching"
        exact
        component={PitchingCenter}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/pitching/new"
        exact
        component={NewPitching}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/releases-schedule/new"
        exact
        component={NewReleasesSchedule}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/releases-schedule/new-with-quincy"
        exact
        component={NewReleasesScheduleOnlyQuincy}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/releases-schedules"
        exact
        component={ReleasesScheduleList}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/metas"
        exact
        component={Metas}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/conexoes"
        exact
        component={RecomendacaoCollab}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/easy-checkout"
        exact
        component={EasyCheckout}
        layout={LayoutBranco}
        autenticacaoNecessaria={false}
      />
      <RotaCustomizada
        path="/:lang?/estagio"
        exact
        component={NewEstagioArtista}
        layout={NewLayout}
      />
      <RotaCustomizada
        path="/:lang?/confirmacao"
        exact
        component={ConfirmacaoCheckout}
        layout={LayoutAutenticado}
        autenticacaoNecessaria={false}
      />
      <RotaCustomizada
        path="/:lang?/convites"
        exact
        component={Convites}
        layout={LayoutAutenticado}
      />

      <RotaCustomizada
        path="/:lang?/aceite-convite"
        exact
        component={AceiteConvite}
        layout={LayoutAutenticado}
      />
      <RotaCustomizada
        path="/:lang?/diagnosticos"
        exact
        component={Diagnosticos}
        layout={NewLayout}
      />
      <RotaCustomizada
        path="/:lang?/diagnostico"
        exact
        component={Diagnostico}
        layout={LayoutEstagio}
      />
      <RotaCustomizada
        path="/:lang?/diagnostico-carreira/:id"
        exact
        component={Diagnostico}
        layout={LayoutEstagio}
      />
      <RotaCustomizada
        path="/:lang?/novo-diagnostico"
        exact
        component={NovoDiagnostico}
        layout={LayoutEstagio}
      />
      <RotaCustomizada
        path="/:lang?/checkout-diagnostico"
        exact
        component={CheckoutDiagnostico}
        layout={LayoutBranco}
      />
      <RotaCustomizada
        path="/:lang?/distribua"
        exact
        component={Distribua}
        layout={LayoutAdiantamento}
      />
      <RotaCustomizada
        path="/:lang?/strm-class"
        exact
        component={StrmClass}
        layout={LayoutAdiantamento}
        autenticacaoNecessaria={false}
      />
      <RotaCustomizada
        path="/:lang?/strm-class/:id"
        exact
        component={StrmClassDetail}
        layout={LayoutAdiantamento}
        autenticacaoNecessaria={false}
      />
      <RotaCustomizada
        path="/:lang?/strm-hero"
        exact
        component={StrmHero}
        autenticacaoNecessaria={false}
        layout={LayoutHero}
      />
      <RotaCustomizada
        path="/:lang?/strm-hero-success"
        exact
        component={StrmHero}
        autenticacaoNecessaria={false}
        layout={LayoutHero}
      />
      <RotaCustomizada
        path="/:lang?/new-assessment"
        exact
        component={NewAssessment}
        autenticacaoNecessaria={false}
        layout={LayoutHero}
      />
      <RotaCustomizada
        path="/:lang?/meus-dados"
        exact
        component={MeusDados}
        layout={LayoutAutenticado}
      />
      <RotaCustomizada
        path="/:lang?/login"
        exact
        component={Login}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/:lang?/reset-senha"
        exact
        component={ResetSenha}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/:lang?/cadastre"
        exact
        component={CadastreSe}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/:lang?/verificacao"
        exact
        component={VerificacaoLogin}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/:lang?/aguardando-login"
        exact
        component={AguardandoLogin}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />

      {/* QUIZ */}
      <RotaCustomizada
        path="/:lang?/quiz"
        exact
        component={Quiz}
        autenticacaoNecessaria={false}
        layout={LayoutQuiz}
      />

      <RotaCustomizada
        path="/:lang?/free-assessment"
        exact
        component={NewQuiz}
        autenticacaoNecessaria={false}
        layout={LayoutHero}
      />

      <RotaCustomizada
        path="/:lang?/unsubscribe/:id"
        exact
        component={Unsubscribe}
        layout={LayoutNaoAutenticado}
      />

      <RotaCustomizada
        path="/:lang?/promo/:id"
        exact
        component={Afiliates}
        layout={LayoutNaoAutenticado}
        autenticacaoNecessaria={false}
      />

      <RotaCustomizada
        path="/:lang?/quincy/:id?"
        exact
        component={QuincySwitch}
        layout={LayoutAdiantamento}
      />

      <RotaCustomizada
        path="/:lang?/tour"
        exact
        component={Tour}
        layout={LayoutNaoAutenticado}
      />

      <RotaCustomizada
        path="/promotion"
        exact
        component={Promotion}
        layout={LayoutAutenticado}
      />

      <RotaCustomizada
        path="/touring"
        exact
        component={Touring}
        layout={LayoutAdiantamento}
      />

      <RotaCustomizada
        path="/pricing"
        exact
        component={Pricing}
        layout={LayoutEstagio}
      />

      <RotaCustomizada
        path="/:lang?/distribuicao"
        exact
        component={CentralDistribuicao}
        layout={LayoutAdiantamento}
      />

      <RotaCustomizada
        path="/:lang?/gerenciamento-artistas"
        exact
        component={GerenciamentoArtistas}
        layout={LayoutAdiantamento}
      />

      <RotaCustomizada
        path="/:lang?/report-upload"
        exact
        component={ReportUpload}
        layout={LayoutAdiantamento}
      />

      {/* COMPARTILHADA */}
      <RotaCustomizada
        component={NotFound}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
    </Switch>
  );
};

export default Routes;
